<script setup lang="ts">
import InvestmentAmountSelect from '../investmentAmount/investmentAmountSelect.vue'
import IncentivesSelect from '../incentives/IncentivesSelect.vue'
import InterestPaymentTypeSelect from '../interestPayment/InterestPaymentTypeSelect.vue'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import { onMounted } from 'vue'
import { trackAnalyticsInvestmentProcessStep1 } from '../../../utilities/useTracking'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { storeToRefs } from 'pinia'

const useInvestmentStore = useInvestmentProcessDataState()
const { incentiveUid, investmentAmount } = storeToRefs(useInvestmentStore)
const campaignData = getCampaignData()

onMounted(() => {
    trackAnalyticsInvestmentProcessStep1()
    const urlParams = new URLSearchParams(window.location.search)
    const iParam = urlParams.get('i')
    if (iParam) {
        const incentive = campaignData.assets_incentives.find((incentive) => incentive.asset_inc_uid === iParam)
        if (incentive) {
            incentiveUid.value = iParam as string
            investmentAmount.value = incentive.incentives_amount as number
        }
    }
})
</script>

<template>
    <div class="px-6 py-6">
        <InterestPaymentTypeSelect
            v-if="getCampaignData().asset_data.needs_contract_type_selection"></InterestPaymentTypeSelect>
        <div
            v-if="getCampaignData().asset_data.needs_contract_type_selection"
            class="my-5 border border-t-gray-200"></div>
        <InvestmentAmountSelect></InvestmentAmountSelect>
        <IncentivesSelect v-if="getCampaignData().assets_incentives.length > 0"></IncentivesSelect>
    </div>
</template>

<style scoped></style>
